export default {
  confirm: 'Confirm',
  cancel: 'Cancel',
  ok: 'ok',
  back: 'Back',
  submit: 'Submit',
  retry: 'Retry',
  delete: 'Delete',
  close: 'Close',
  openInNewWindow: 'Open in a new window',
  codeNotReceived: 'Code not received?',
  forgotPassword: 'Forgot your password?',
  or: 'OR',
  disable: 'Disable',
  save: 'Save',
  login: 'Log in',
  logout: 'Log out',
  edit: 'Edit',
  unknownError: 'An error occurred',
  chooseLanguage: 'Choose language',
  waitBeforeRetry: 'Please wait {timeRemaining} before retry',
  yes: 'Yes',
  no: 'No',
  dontAsk: 'Do not ask again'
}
